import { 
   Calendar,
   CalendarFetchArgs,
   getCalendarEvents
} from '../assets/ts/data/calendar'
import useServerData from './use-server-data'

function useCalendar(
    fetchArgs: CalendarFetchArgs,
    waitOnParentDependency = false
  ) {
    const {
      data: CalendarData,
      error: CalendarDataError,
      fetchData: fetchCalendarData,
      isLoading: CalendarDataIsLoading,
    } = useServerData<Calendar, CalendarFetchArgs>(
        getCalendarEvents,
      fetchArgs,
      waitOnParentDependency
    )
  
    return {
      CalendarData,
      CalendarDataError,
      CalendarDataIsLoading,
      fetchCalendarData,
    }
  }
  
  export default useCalendar